import React, { useState, useEffect } from "react";
import { $t } from '@/modules/i18n';
import cx from 'classnames';

const QuestionList = ({ active = [], flag = false }) => {
  let str = `${flag}`
  return (
    <div className="list">
      {
        (active.list || []).map((section, index) => (
          <div className="item" key={section.question}>
            <div className="cover collapsed" id={`${str}-${section.question}-faq-${index}`} data-toggle="collapse" data-target={`#${str}-${section.question}-ans-${index}`} aria-expanded="false" aria-controls={`${str}-${section.question}-ans-${index}`}>
              {$t(section.question)}
            </div>
            <div id={`${str}-${section.question}-ans-${index}`} className="answers collapse" aria-labelledby={`${str}-${section.question}-faq-${index}`} data-parent="#faq">
              {
                section.desc.map(desc => <p dangerouslySetInnerHTML={{ __html: $t(desc) }} key={desc} />)
              }
            </div>
          </div>
        ))
      }
    </div>
  )
}

export default ({ message = {}, children }) => {
  const [active, setActive] = useState(message.sections ? message.sections[0] : {});

  function toggleSection(index,type) {
    setActive(message.sections[index]);
    if (type && type === 'mobile') {
      setTimeout(() => {
        changeAnchor(`faq-section-${index}`)
      }, 310);
    }
  }
   /* 锚链接跳转 */
  function changeAnchor(anchorName) {
    let element = document.getElementById(anchorName);
    if (element) {
      let height = document.getElementById(anchorName).offsetTop - 70; //计算需要向上移动的距离
      window.scrollTo(0, height);
    }
  }

  useEffect(() => {
    message && message.sections && !Object.keys(active).length && setActive(message.sections[0])
  })

  return (
    <section id="faq" className={cx('faq-module-wrapper')}>
      <div className="faq-title">{$t(message.title)}</div>
      <div>
          <div className="pc">
            <div className="content">
              <ul className="faq-sections">
                {
                  (message.sections || []).map((section, index) => (
                    <li className={`faq-section-title${section.title === active.title ? ' active' : ''}`} onClick={() => toggleSection(index)} key={section.title || index}>{$t(section.title)}</li>
                  ))
                }
              </ul>
                <QuestionList active={active} flag={false}/>
            </div>
          </div>
        </div>
      { children}
    </section>
  )
};
